import React from "react";
import StatusBox from "./StatusBox";
import AddButton from "./AddButton";

/**
 * <SectionWithAdd id={} plType={} count={} editMode={} addItem={} progressA={} toggleProgressA={} sectionName={} hideAddBtn={} />
 */
const SectionWithAdd = (props) => {
  try {
    const addBtn =
      props.editMode && !props.hideAddBtn ? (
        <AddButton
          addItem={(e) =>
            props.addItem(
              {
                type: props.type,
                plType: props.plType,
                sequence: 1,
              },
              e
            )
          }
        />
      ) : (
        ""
      );

    return (
      <section id={props.id} className="top-buffer">
        <h4 className="d-flex flex-row justify-content-between">
          {props.sectionName}
          {addBtn}
        </h4>
        <h5 className="d-flex flex-row justify-content-left">
          <StatusBox
            progressA={props.progressA}
            index={props.progIndex}
            sectionName={`${props.sectionName} Complete?`}
            editMode={props.editMode}
            handleChange={props.toggleProgressA}
          />
        </h5>
        {props.children}
      </section>
    );
  } catch (e) {
    console.error(e);
  }
};

export default SectionWithAdd;
